import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../css/DeleteWithConfirmation.css";

export default function DeleteWithConfirmation({
  isOpen,
  onConfirm,
  onCancel,
  title = "Confirm Deletion",

  confirmText = "Yes, Delete",
  cancelText = "Cancel",
}) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="delete-confirm-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="delete-confirm-modal"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
          >
            <h3>{title}</h3>
          
            <div className="delete-confirm-buttons">
              <button className="confirm" onClick={onConfirm}>
                {confirmText}
              </button>
              <button className="cancel" onClick={onCancel}>
                {cancelText}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
